import fireConfig from "./fire/fields";
import othersConfig from "./others/fields";
import NewRequestDataConfig from "./types";

const getFieldsConfig = (branchId: number): NewRequestDataConfig => {
    return fireConfig;
};

export default getFieldsConfig;